import React from 'react';
import menuIcon from '../../../assets/images/menu.svg';

import IconButton from '@material-ui/core/IconButton';
import TimetableTitle from '../../../components/application/timetable/TimetableTitle';
import Profile from './Profile';
import TimetableFilters from '../timetable/filter/TimetableFilters';

const TopMenu = ({
    openMenu,
    isTimetable,
    partnerOptions,
    showDot,
    selectedPartner,
    user,
    selectedPartnerName,
    events,
    title,
    isSearchOpen,
    hasFilter,
    openSearch,
    selectedEventId,
    isViewFilterOpen,
    openViewOptions,
    selectPartner,
    toggleFiltersOpen,
    filtersOpen,
    toggleActivityOpen,
    activityOpen,
    logOut
}) => (
    <nav className="ckp-top-menu">
        <a className="ckp-top-menu-open">
            <IconButton onClick={openMenu}>
                <img src={menuIcon} alt="Menu" />
            </IconButton>
        </a>
        {isTimetable && <TimetableTitle selectedEvent={selectedEventId} events={events} title={title} />}
        <Profile
            selectPartner={selectPartner}
            logOut={logOut}
            partnerOptions={partnerOptions}
            selectedPartner={selectedPartner}
            user={user}
            isTimetable={isTimetable}
            selectedPartnerName={selectedPartnerName}
        />
        {isTimetable && (
            <TimetableFilters
                showDot={showDot}
                hasFilter={hasFilter}
                toggleFiltersOpen={toggleFiltersOpen}
                toggleActivityOpen={toggleActivityOpen}
                isViewFilterOpen={isViewFilterOpen}
                openViewOptions={openViewOptions}
                isSearchOpen={isSearchOpen}
                openSearch={openSearch}
                isMobile={true}
                activityOpen={activityOpen}
                filtersOpen={filtersOpen}
            />
        )}
    </nav>
);

export default TopMenu;



// WEBPACK FOOTER //
// ./src/components/application/menu/TopMenu.js